import React from 'react'
import SubscriptionInfoModal from './SubscriptionInfoModal'
import { Column, Columns } from '../../bulma'
import { PlatinumRewardsLogo } from '../../core/icons'


function PlatinumInfoModal(props) {
  const { checkoutStep, ...rest } = props

  const content = () => (
    <div className="content">
      <Columns>
        <Column>
          <img src="https://s3.amazonaws.com/deseretbook/misc/assets/platinum/sign_up_offers.png" className="platinum-offers" />
        </Column>
      </Columns>
      <Columns>
        <Column>
          <ul>
            <li>
              <strong>Earn 10% back in points</strong> on most purchases, including your first purchase. Get $10 back in points for every 1000 points earned. Points are easily redeemable online or in-store. <a href="/rewards/faq">Some exclusions apply, see FAQ for details.</a>
            </li>
            <li>
              <strong>Save up to 43%</strong> on your Bookshelf Plus subscription.
            </li>
            <li>
                Receive a <strong>free</strong> one year subscription to LDS Living Magazine.
            </li>
          </ul>
        </Column>
        <Column>
          <ul>
            <li>
                Get a <strong>free</strong> birthday gift during your birth month. Give us your email and birth month and we'll send a coupon during the month of your birthday for a free gift.
            </li>
            <li>
                Access to over 100+ unique offers and benefits via your Platinum Account page.
            </li>
          </ul>
        </Column>
      </Columns>
    </div>
  )

  return (
    <SubscriptionInfoModal
      title={<PlatinumRewardsLogo className="modal-logo" />}
      modal="platinum rewards"
      content={content()}
      checkoutStep={checkoutStep}
    />
  )
}

export default PlatinumInfoModal
